import Checkbox from '@atlaskit/checkbox';
import React from 'react';

interface SelectionsEntryCheckboxProps {
  entryId: string;
  index: number;
}

/**
 * This component is rendered when the databasesSelectionsPerformance experiment flag is enabled.
 * Input events are captured by the selections package for optimized performance.
 */
const SelectionsEntryCheckbox = ({ entryId, index }: SelectionsEntryCheckboxProps) => (
  <Checkbox
    className="selections-entry-checkbox"
    data-entry-id={entryId}
    data-row-index={index}
  />
);

export default SelectionsEntryCheckbox;
